'use strict';

exports.__esModule = true;
exports.LANGUAGE_ZOOM_FACTORS = undefined;

var _LANGUAGE_ZOOM_FACTOR;

exports.calcDialogZoom = calcDialogZoom;

var _i18n = require('@kdocs/i18n');

var LANGUAGE_ZOOM_FACTORS = exports.LANGUAGE_ZOOM_FACTORS = (_LANGUAGE_ZOOM_FACTOR = {}, _LANGUAGE_ZOOM_FACTOR[_i18n.LANG_TAG_ZH_CN] = 1, _LANGUAGE_ZOOM_FACTOR[_i18n.LANG_TAG_EN_US] = 1.15, _LANGUAGE_ZOOM_FACTOR[_i18n.LANG_TAG_TH_TH] = 1.15, _LANGUAGE_ZOOM_FACTOR[_i18n.LANG_TAG_JA_JP] = 1.15, _LANGUAGE_ZOOM_FACTOR[_i18n.LANG_TAG_RU_RU] = 1.25, _LANGUAGE_ZOOM_FACTOR[_i18n.LANG_TAG_PT_PT] = 1.25, _LANGUAGE_ZOOM_FACTOR[_i18n.LANG_TAG_ES_ES] = 1.25, _LANGUAGE_ZOOM_FACTOR[_i18n.LANG_TAG_DE_DE] = 1.25, _LANGUAGE_ZOOM_FACTOR[_i18n.LANG_TAG_FR_FR] = 1.25, _LANGUAGE_ZOOM_FACTOR);

function calcDialogZoom() {
  return LANGUAGE_ZOOM_FACTORS[(0, _i18n.getLang)()] || 1;
}